import React, { FunctionComponent, useState } from "react";
import { useSnackbar } from "notistack";
import { CenterContainer } from "@bg/shared/lib/components";
import UserManagementWarningComponent from "./UserManagementWarningComponent";
import { attestateMeAsUserManager } from "@bg/shared/lib/dal/physicians";

const UserManagementWarning: FunctionComponent = () => {
  const { enqueueSnackbar } = useSnackbar();

  function onConfirmClick(e: React.SyntheticEvent) {
    e.preventDefault();
    attestateMeAsUserManager()
      .then(() => window.location.reload())
      .catch(() => enqueueSnackbar("Failed to confirm"));
  }

  const [agreed, setAgreed] = useState(false);
  const onAgreedChange = (agreedValue: boolean) => setAgreed(agreedValue);
  return (
    <div>
      <CenterContainer
        style={{
          minHeight: "calc(50vh - 3em)",
          paddingBottom: "2em",
        }}
      >
        <UserManagementWarningComponent
          agreedValue={false}
          onAgreedChange={onAgreedChange}
        />
        <div>
          <button type="button" onClick={onConfirmClick} disabled={!agreed}>
            Submit
          </button>
        </div>
      </CenterContainer>
    </div>
  );
};

export default UserManagementWarning;
